module.exports = __webpack_public_path__ + "img/tushi4.e4396d78.png";